import { useQuery } from '@tanstack/react-query';
import { getCalibrationPlanning } from '../api';
import type { CalibrationPlanningParams } from '../types';

export const calibrationPlanningKeys = {
  all: ['calibration-planning'] as const,
  planning: (params?: CalibrationPlanningParams) =>
    [...calibrationPlanningKeys.all, params] as const,
};

/**
 * Hook to fetch the calibration planning cockpit data.
 * staleTime is 5 minutes to avoid hammering the expensive planning query.
 */
export function useCalibrationPlanning(params?: CalibrationPlanningParams) {
  return useQuery({
    queryKey: calibrationPlanningKeys.planning(params),
    queryFn: () => getCalibrationPlanning(params),
    staleTime: 5 * 60 * 1000,
  });
}
